export var getIds = _ref => {
  var {
    id
  } = _ref;
  return {
    ids: id ? {
      root: id,
      touchablePreview: "".concat(id, "__preview__touchable"),
      label: "".concat(id, "__label"),
      header: "".concat(id, "__header"),
      title: "".concat(id, "__title"),
      linkWrapper: "".concat(id, "__link-wrapper"),
      linkParagraph: "".concat(id, "__link-paragraph"),
      link: "".concat(id, "__link"),
      firstItemContentWrapper: "".concat(id, "__first-item-content-wrapper"),
      contentWrapper: "".concat(id, "__content-wrapper"),
      contentParagraph: "".concat(id, "__content-paragraph"),
      selectorWrapper: "".concat(id, "__selector-wrapper"),
      selector: "".concat(id, "__selector"),
      line: index => "".concat(id, "__line__").concat(index)
    } : {
      line: () => undefined
    }
  };
};
//# sourceMappingURL=getIds.js.map